import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { FOOTER_PAGES, SiteFooter } from "@/components/SiteFooter";
import { DOC_VERSIONS, LEGAL_UPDATED } from "@/lib/legal";
import { DocRenderer } from "@/components/info/DocRenderer";
import { HelpCenter } from "@/components/info/HelpCenter";
import { ContactInfo } from "@/components/info/ContactInfo";
import { privacy, cookies, subprocessors, dpa } from "@/content/legalPrivacy";
import { legalNotice, cgu, commercial, vulnerability, security, about } from "@/content/legalTerms";

const DOCS = {
  confidentialite: privacy, cookies, "sous-traitants": subprocessors, dpa, "mentions-legales": legalNotice, cgu,
  "conditions-commerciales": commercial, "signalement-vulnerabilite": vulnerability, "securite-confiance": security, "a-propos": about,
};

const Body = ({ slug }) => {
  if (slug === "centre-aide") return <HelpCenter />;
  if (slug === "contact") return <ContactInfo />;
  if (DOCS[slug]) return <DocRenderer doc={DOCS[slug]} />;
  return <p className="text-muted-foreground">Cette page n'existe pas.</p>;
};

const fmt = (d) => new Date(`${d}T00:00:00`).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });

export default function InfoPage() {
  const { slug } = useParams();
  const { user } = useAuth();
  const title = FOOTER_PAGES[slug] || "Page introuvable";
  useEffect(() => { window.scrollTo(0, 0); }, [slug]);
  return (
    <div className="grain flex min-h-screen flex-col">
      <main className="relative z-10 mx-auto w-full max-w-3xl flex-1 px-4 py-12">
        <Link to={user ? "/" : "/connexion"} data-testid="info-back-link" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-amber-500">
          <ArrowLeft className="h-4 w-4" /> {user ? "Retour à l'application" : "Retour à la connexion"}
        </Link>
        <h1 data-testid="info-title" className="mt-6 font-heading text-4xl font-bold sm:text-5xl">{title}</h1>
        {DOC_VERSIONS[slug] && (
          <p data-testid="info-version" className="mt-3 text-xs text-muted-foreground">
            Version {DOC_VERSIONS[slug]} · Dernière mise à jour : {fmt(LEGAL_UPDATED)}
          </p>
        )}
        <div className="mt-8" data-testid="info-content"><Body slug={slug} /></div>
      </main>
      <SiteFooter className="relative z-10 bg-card" />
    </div>
  );
}
